<template>
  <main
    v-if="home"
    class="home">
    <ul
      class="featured">
      <li
        v-for="(featured, key) in home.featured"
        :key="`featured${(key + 1)}`"
        class="featured__item"
        :class="{
          'featured__item--active': activeItem === key
        }">
        <img
          :class="{
            'portrait': featured.image.height >= featured.image.width,
            'landscape': featured.image.width > featured.image.height
          }"
          :src="featured.image.url">
        <aside
          @mouseenter="activeItem = key"
          @click="updateActive(key)"
          :style="{
            width: Number.parseInt((100 / home.featured.length), 10) + '%',
            left: (Number.parseInt((100 / home.featured.length), 10) * key) + '%',
            right: ((((home.featured.length - key)) * 18) + 10) + 'px',
            height: '100vh',
            minHeight: '720px'
          }"></aside>
      </li>
    </ul>

    <Navigation :active="true" />

  </main>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
  name: 'Home',
  components: {
    Navigation
  },
  data() {
    return {
      activeItem: 0,
      home: null,
      interval: false
    }
  },
  async created() {
    this.home = await this.getHome()

    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

    this.$Progress.finish()

    if (width < 1024) {
      this.resetInterval()
    }
  },
  methods: {
    getHome() {
      return new Promise((resolve, reject) => {
        fetch(`${process.env.VUE_APP_API_ADDRESS}/home`, {
          headers: {
            'Authorization': `Basic YXBwOmNJbnAgSnUxOSBBNWRkIEVEVkIgREViNCBvZ2Rp`
          }
        })
        .then(response => response.json())
        .then(result => resolve(result))
      })
    },
    updateActive(key) {
      this.activeItem = key

      this.resetInterval()
    },
    resetInterval() {
      if (this.interval) {
        window.clearInterval(this.interval)
      }

      this.interval = window.setInterval(() => {
        if (this.activeItem < this.home.featured.length - 1) {
          this.activeItem++
        } else {
          this.activeItem = 0
        }
      }, 3000)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$Progress.start()
    })
  }
}
</script>

<style lang="scss" scoped>
.home {
  @include page($margin: false);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 720px;

  .featured {
    &__item {
      height:calc(100vh - 0rem);
      min-height: 720px;
      position: absolute;
      top: 0px;
      left: -#{$site-padding-lrg};
      width: calc(100% + #{$site-padding-lrg});
      // visibility: hidden;

      &--active {
        display: block;

        img {
          opacity: 1 !important;
          transition-delay: 150ms;
          transition-duration: 400ms;
        }
      }

      img {
        width:100%;
        height:100%;
        display:flex;
        object-fit: contain;
        object-position: 50% 50%;
        opacity: 0;
        transition: opacity 250ms ease-in-out;

        &.landscape {
          object-fit: cover;
        }
      }

      aside {
        display: block;
        top: 0px;
        position: absolute;
        z-index: 1;
        opacity: 0.25;
      }
    }
  }

  @include mobile {
    height: 100%;
    margin-top: 0px !important;
    min-height: 100vh;

    .featured {
      // display:none;

      &__item {
        min-height: 100%;

        &--active {
          aside {
            opacity: 0.45 !important;
          }
        }

        aside {
          width: 10px !important;
          height: 10px !important;
          min-height: unset !important;
          border-radius: 14px;
          background-color: black;
          opacity: 0.25;
          transition: opacity 200ms ease-in-out;
          top: unset !important; // calc(100% - 14px - #{$site-padding--m * 2});
          left: unset !important;
          bottom: calc(#{$site-padding--m} + 5px);
          transform: translateX(10px);
          display:none;
        }
      }
    }
  }
}
</style>
